import React, { memo, useState, useEffect } from "react";
import {
	Row, Col,
	Card, Button,
	Modal
} from "react-bootstrap";

import CountdownTimer from "components/FullTest/CountdownTimer";
import tenMinutes from "components/10-mins.jpg";

const BREAK_TIME = 10;
const Break = memo( function Break({
	mock, setSection
}) {
	const [timeUp, setTimeUp] = useState(false);

	useEffect(() => {
		if (mock.break === 1) { // somehow its value is 1 when no break is offered.
			setSection(prev => (prev + 1));
		}
	}, []);

	const finishBreak = (arg = null) => {
		setSection(prev => (prev + 1));
	};

	// mock.break = 1 means no break.
	// mock.break = 0 means break.

	return (
		<div className="content questionsArea mock-container">
			{mock.break === 0 &&
				<Row>
					<Col xs={12} className="mock-resource-text mock-header-gap" >
						<Card className="mock-header-gap border-0 shadow-none">
							<Card.Header className="mock-resource-text">
								<Row>
									{/* <Col xs={6}>
										<Card.Title tag="h4">
											{mock.title}
										</Card.Title>
									</Col> */}
									
									<Col xs={6}>
										<div className="text-right questionTime"></div>
									</Col>
								</Row>
							</Card.Header>
							
							<Card.Body className="mock-resource-text">
								<Row className='unselectable'>
									<Col lg={12}>
										<CountdownTimer
											time={BREAK_TIME}
											setTimeUp={finishBreak}
										/>
										<h4 className="mt-0">Optional Break</h4>
										<h6>You may now take a break up to 10 minutes. If you want to take a break you must leave the testing room.</h6>
										<ol>
											<li>If you want to take a break raise your hand to get the attention of the Test Administrator.</li>
											<li>If you do not want to take a break click on next button below to continue the test.</li>
										</ol>
										<img src={tenMinutes} />
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
					
					<Col xs={12}>
						<div className="bottomBtns mock-container">
							<Row>
								<Col xs={9}>
									<Button
										variant="primary"
										onClick={finishBreak}
										size="xs"
									>Skip wait</Button>
								</Col>
								<Col xs={3}></Col>
							</Row>
						</div>
					</Col>
				</Row>
			}
		</div>
	);
});

export default Break;